<template>
    <div v-if="hasher.hash_name" style="">
        <div style="display: grid; grid-template-columns: 1fr 1fr; grid-gap: 1em; grid-template-rows: 3em 2em auto; justify-content: center; align-items: center; align-content: center">
            <h3 style="display: flex;justify-content: center; align-self: start; grid-column-start: 1; grid-column-end: -1">{{hasher.hash_name}}</h3>
            <div style="display: flex;justify-content: center;align-items: center;;">Trails Hared: {{hasher.trails_hared}}</div>
            <div style="display: flex; justify-content: center; align-items: center;">Trails Ran: {{hasher.trails_ran}}</div>
        </div>
    </div>
</template>

<script>
  import axios from 'axios';
  import HasherDao from "../daos/HasherDao";
  export default {
    name: 'Hasher',
    props: ['hasher'],
    data: function () {
    },
    beforeMount: function () {
    },
    watch: {
    },
    methods: {
    }
  }
</script>
<style lang="scss" scoped>
</style>
